import type { AppRouter } from "@sp-crm/server/rpc";
import type { inferProcedureOutput } from "@trpc/server";
import React from "react";

type SendPreview = inferProcedureOutput<AppRouter["homeCareLeadPartnerSend"]["preview"]>;

type SendSection = SendPreview["sections"][number];

const SendFieldRow: React.FC<{ label: string; value: string | null }> = ({
    label,
    value,
}) => (
    <div className="flex gap-3 py-1 text-sm">
        <dt className="w-28 shrink-0 text-gray-500 sm:w-36">{label}</dt>
        <dd className={value ? "text-gray-900" : "text-gray-400 italic"}>
            {value ?? "—"}
        </dd>
    </div>
);

export const SendSectionList: React.FC<{ sections: SendSection[] }> = ({ sections }) => (
    <div className="space-y-4">
        {sections.map(section => (
            <section key={section.title}>
                <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                    {section.title}
                </h3>
                <dl className="mt-1 divide-y divide-gray-100 border-t border-gray-100">
                    {section.fields.map(field => (
                        <SendFieldRow
                            key={field.label}
                            label={field.label}
                            value={field.value}
                        />
                    ))}
                </dl>
            </section>
        ))}
    </div>
);

export const SendReferralSource: React.FC<{
    referralSource: string | null;
    partnerName: string;
}> = ({ referralSource, partnerName }) => (
    <section>
        <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-500">
            Referral source
        </h3>
        <p
            className={`mt-1 text-sm ${
                referralSource ? "text-gray-900" : "text-gray-400 italic"
            }`}>
            {referralSource ?? "None"}
        </p>
        <p className="mt-1 text-xs text-gray-500">
            {referralSource
                ? `Matched to an existing referral source in ${partnerName}, or created there if it is new.`
                : `No referral source will be set in ${partnerName}.`}
        </p>
    </section>
);
